// extracted by mini-css-extract-plugin
module.exports = {"CheckBox":"eL7zOhkG","btn":"mTZi3Q3R"};